"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'keyword',
  props: {
    isDisabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    labelarr: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      val: ''
    };
  },
  methods: {
    labelhandleClose: function labelhandleClose(tag) {
      var index = this.labelarr.indexOf(tag);
      this.labelarr.splice(index, 1);
    },
    addlabel: function addlabel() {
      var count = this.labelarr.indexOf(this.val);
      if (count === -1) {
        this.labelarr.push(this.val);
      }
      this.val = '';
      this.$emit('getLabelarr', this.labelarr);
    }
  }
};